export default __webpack_public_path__ + "static/media/hub-logo.8251024a.svg";